import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/lf_logo.png";
import "./Sidebar.css";

// Versione = timestamp Unix del commit HEAD al momento del build.
// Generato in frontend/package.json: REACT_APP_BUILD_VERSION=$(git log -1 --format=%ct).
// Vantaggio: stesso commit -> stesso valore in staging e prod, anche se i due
// ambienti vengono buildati separatamente. In dev (npm start) la var non esiste.
const APP_VERSION = process.env.REACT_APP_BUILD_VERSION || "__DEV__";

const Sidebar = ({mobileOpen, onMobileClose}) => {
    const role = localStorage.getItem("role");
    const [collapsed, setCollapsed] = useState(false);
    const versionLabel = APP_VERSION === "__DEV__" ? "v dev" : `v ${APP_VERSION}`;

    const toggleSidebar = () => {
        if (mobileOpen) {
            onMobileClose();
        } else {
            setCollapsed(!collapsed);
        }
    };

    return (
        <>
        <div
            className={`sidebar-backdrop ${mobileOpen ? 'visible' : ''}`}
            onClick={onMobileClose}
        />
        <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
            {/* Header */}
            <div className="sidebar-header">
                <div className="logo-container" onClick={collapsed ? toggleSidebar : undefined} style={{ cursor: collapsed ? 'pointer' : 'default' }}>
                    <div className="logo">
                        <img src={logo} alt="LF23 Logo" />
                    </div>
                    <div className="logo-text">
                        <div className="logo-title">LF23</div>
                        <div className="logo-subtitle">Dashboard Operativa</div>
                    </div>
                </div>
                {!collapsed && (
                    <button className="toggle-btn" onClick={toggleSidebar}>
                        <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </button>
                )}
            </div>

            {/* Navigation */}
            <nav className="sidebar-nav" onClick={mobileOpen ? onMobileClose : undefined}>
                {/* HOME */}
                <div className="nav-section">
                    <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="7" height="7"></rect>
                            <rect x="14" y="3" width="7" height="7"></rect>
                            <rect x="14" y="14" width="7" height="7"></rect>
                            <rect x="3" y="14" width="7" height="7"></rect>
                        </svg>
                        <span className="nav-label">Dashboard Home</span>
                    </NavLink>
                </div>

                {/* SEZIONI */}
                <div className="nav-section">
                    <div className="nav-section-title">Sezioni</div>

                    <NavLink to="/reportistica" className={({ isActive }) => `nav-item ${isActive ? 'active-reportistica' : ''}`}>
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="20" x2="18" y2="10"></line>
                            <line x1="12" y1="20" x2="12" y2="4"></line>
                            <line x1="6" y1="20" x2="6" y2="14"></line>
                        </svg>
                        <span className="nav-label">Reportistica</span>
                        <svg className="nav-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </NavLink>

                    <NavLink to="/automazione" className={({ isActive }) => `nav-item ${isActive ? 'active-automazione' : ''}`}>
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                        </svg>
                        <span className="nav-label">Automazione Processi</span>
                        <svg className="nav-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </NavLink>

                    <NavLink to="/produttivita" className={({ isActive }) => `nav-item ${isActive ? 'active-operations' : ''}`}>
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                        </svg>
                        <span className="nav-label">Produttività</span>
                        <svg className="nav-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </NavLink>

                    <NavLink to="/ai-agents" className={({ isActive }) => `nav-item ${isActive ? 'active-ai' : ''}`}>
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                            <path d="M2 17l10 5 10-5"></path>
                            <path d="M2 12l10 5 10-5"></path>
                        </svg>
                        <span className="nav-label">AI Agents</span>
                        <svg className="nav-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </NavLink>

                    <NavLink to="/applicativi" className={({ isActive }) => `nav-item ${isActive ? 'active-apps' : ''}`}>
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="7" height="7"></rect>
                            <rect x="14" y="3" width="7" height="7"></rect>
                            <rect x="3" y="14" width="7" height="7"></rect>
                            <rect x="14" y="14" width="7" height="7"></rect>
                        </svg>
                        <span className="nav-label">Applicativi LF23</span>
                        <svg className="nav-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </NavLink>
                </div>

                {/* AMMINISTRAZIONE */}
                {(role === "admin" || role === "superadmin") && (
                    <div className="nav-section">
                        <div className="nav-section-title">Amministrazione</div>

                        <NavLink to="/gestione-utenti" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <span className="nav-label">Gestione Utenze</span>
                        </NavLink>

                        <NavLink to="/upload" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline points="14 2 14 8 20 8"></polyline>
                                <line x1="16" y1="13" x2="8" y2="13"></line>
                                <line x1="16" y1="17" x2="8" y2="17"></line>
                                <polyline points="10 9 9 9 8 9"></polyline>
                            </svg>
                            <span className="nav-label">Caricamento Files</span>
                        </NavLink>
                    </div>
                )}
            </nav>

            {/* Footer con numero versione: timestamp Unix del commit HEAD */}
            <div
                className="sidebar-footer"
                title={
                    APP_VERSION === "__DEV__"
                        ? "Build locale (dev server)"
                        : `Build del commit del ${new Date(parseInt(APP_VERSION, 10) * 1000).toLocaleString("it-IT")}`
                }
            >
                <span className="sidebar-version">{versionLabel}</span>
            </div>
        </aside>
        </>
    );
};

export default Sidebar;
